const { REACT_APP_ENDPOINT = '' } = process.env

export const COMPLIANTS_ESCALATION_DATA = {
  blocks: [
    {
      key: '6efkk',
      text: 'Level 1: Customers can lodge their queries, requests, complaints and feedback at care@jiopay.in. All queries, requests, complaints and feedback received from the customers will be attended promptly and within 10 working days from the date of receipt in any case.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [
        { offset: 0, length: 262, style: '#757575' },
        { offset: 0, length: 8, style: 'BOLD' },
        { offset: 81, length: 14, style: '#0070b6' },
      ],
      entityRanges: [{ offset: 81, length: 14, key: 0 }],
      data: {},
    },
    {
      key: '2bvpn',
      text: 'Merchant Partners can lodge their queries, requests, complaints and feedback at merchant.support@jiopay.in. JPSL endeavors to resolve all queries, requests, complaints and feedback received from the Merchant Partners promptly and within 10 working days from the date of receipt in any case.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [
        { offset: 0, length: 290, style: '#757575' },
        { offset: 80, length: 26, style: '#0070b6' },
      ],
      entityRanges: [{ offset: 80, length: 26, key: 1 }],
      data: {},
    },
    { key: '135mr', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: '8pfsu',
      text: 'Level 2: In case of non-redressal of the complaint within the specified time period or an unsatisfactory resolution at Level 1, customers can escalate the matter to Ms. Kausar Hasan (Nodal Officer) by sending an email at nodal.officer@jiopay.in. The Nodal Officer will get back to the customer within 10 working days from the date of escalation.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [
        { offset: 0, length: 8, style: 'BOLD' },
        { offset: 0, length: 345, style: '#757575' },
        { offset: 221, length: 23, style: '#0070b6' },
      ],
      entityRanges: [{ offset: 221, length: 23, key: 2 }],
      data: {},
    },
    { key: '28psr', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: 'c0tbb',
      text: 'Level 3: In case of non-redressal of the complaint within the specified time period or an unsatisfactory resolution at Level 2, customers can raise the case to Mr. Harish Nambiar (Principal Nodal Officer) by sending an email at nodal.principal@jiopay.in. The Principal Nodal Officer will get back to the customer within 10 working days from the receipt of the email.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [
        { offset: 0, length: 366, style: '#757575' },
        { offset: 0, length: 8, style: 'BOLD' },
        { offset: 228, length: 25, style: '#0070b6' },
      ],
      entityRanges: [{ offset: 228, length: 25, key: 3 }],
      data: {},
    },
    { key: 'e954c', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: 'ef8gf',
      text: 'Level 4: If the customer is not satisfied with the resolution provided or does not receive any resolution within 30 days from the date of complaint, the customer can reach out to the ‘Ombudsman for Digital Transactions’ for an independent review through their Complaint Lodging Portal - https://cms.rbi.org.in/.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [
        { offset: 0, length: 311, style: '#757575' },
        { offset: 0, length: 8, style: 'BOLD' },
        { offset: 287, length: 23, style: '#0070b6' },
      ],
      entityRanges: [{ offset: 287, length: 23, key: 4 }],
      data: {},
    },
    { key: '85nnu', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: 'avk1o',
      text: 'The salient features of the scheme -',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 36, style: '#757575' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '1sjcb',
      text: 'https://rbidocs.rbi.org.in/rdocs/content/pdfs/RBIOS2021_amendments05082022.pdf',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [
        { offset: 0, length: 78, style: '#757575' },
        { offset: 0, length: 78, style: '#0070b6' },
      ],
      entityRanges: [{ offset: 0, length: 78, key: 5 }],
      data: {},
    },
    { key: '848gl', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: 'bc1p3',
      text: 'For more details on Complaint Resolution and Escalation Matrix, kindly refer to our Grievance Redressal Policy at -',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [
        { offset: 0, length: 115, style: '#0070b6' },
        { offset: 0, length: 115, style: '#757575' },
      ],
      entityRanges: [],
      data: {},
    },
    {
      key: 'e45kc',
      text: 'https://jiopay.in/docs/Grievance/Grievance-Redressal-Policy.pdf',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [
        { offset: 0, length: 63, style: '#757575' },
        { offset: 0, length: 63, style: '#0070b6' },
      ],
      entityRanges: [{ offset: 0, length: 63, key: 6 }],
      data: {},
    },
  ],
  entityMap: {
    '0': { type: 'LINK', mutability: 'MUTABLE', data: { url: 'mailto:care@jiopay.in' } },
    '1': { type: 'LINK', mutability: 'MUTABLE', data: { url: 'mailto:merchant.support@jiopay.in' } },
    '2': { type: 'LINK', mutability: 'MUTABLE', data: { url: 'mailto:nodal.officer@jiopay.in' } },
    '3': { type: 'LINK', mutability: 'MUTABLE', data: { url: 'mailto:nodal.principal@jiopay.in' } },
    '4': { type: 'LINK', mutability: 'MUTABLE', data: { url: 'https://cms.rbi.org.in/' } },
    '5': {
      type: 'LINK',
      mutability: 'MUTABLE',
      data: { url: 'https://rbidocs.rbi.org.in/rdocs/content/pdfs/RBIOS2021_amendments05082022.pdf' },
    },
    '6': {
      type: 'LINK',
      mutability: 'MUTABLE',
      data: { url: `${REACT_APP_ENDPOINT}/docs/Grievance/Grievance-Redressal-Policy.pdf` },
    },
  },
}
